import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { CalculationFieldsService } from './calculation-fields.service';
import { Field } from 'app/interfaces/fields';
import { SelectedFieldEnum } from 'app/interfaces/fields.dto';

@Component({
  selector: 'app-calculation-fields',
  templateUrl: './calculation-fields.component.html',
  styleUrls: ['./calculation-fields.component.scss']
})
export class CalculationFieldsComponent {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.calculationFields.length > 0) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.highlightedIndex = (this.highlightedIndex + 1) % this.calculationFields.length;
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.highlightedIndex = (this.highlightedIndex - 1 + this.calculationFields.length) % this.calculationFields.length;
      } else if (event.key === 'Enter') {
        event.preventDefault();
        const selectedField = this.calculationFields[this.highlightedIndex];
        if (selectedField) {
          this.selectCalculation(selectedField);
        }
      }
    }
  }

  @ViewChild('calculation_text', { static: false }) calculation_text: ElementRef;

  private _uuid: string | null;
  public isCalculationChecked = false;
  public enable_calculation = 0;
  public calculationFields: Field[] = [];
  public calculation = '';
  public calculation_decimal = '';
  public mentionText = '';
  public fieldData: Field;
  public SelectedFieldEnum = SelectedFieldEnum;
  public highlightedIndex = 0;
  constructor(
    private elementRef: ElementRef,
    private calcService: CalculationFieldsService
  ) { }

  @Input()
  set uuid(value: string) {
    this._uuid = value;
    this.fieldData = this.calcService.prepareConditionalFields(value) || null;
    if (this.fieldData) {
      this.enable_calculation = this.fieldData.enable_calculation || 0;
      this.calculation = this.fieldData.calculation || '';
      this.calculation_decimal = this.fieldData.calculation_decimal || '';
    }
  }
  get uuid() { return this._uuid; }

  addCalculation(event) {
    const checked = event.target.checked ? 1 : 0;
    this.enable_calculation = checked;
    this.calcService.updateEnableCalculation(this._uuid, checked);

    if (!checked) {
      this.calculation = '';
      this.calcService.removeCalculation(this._uuid);
    }
  }

  searchTextField(event: KeyboardEvent) {
      // if navigation keys -> don't trigger search again
    if (event && ['ArrowUp', 'ArrowDown', 'Enter'].includes(event.key)) {
      return;
    }

    const inputElement = this.calculation_text.nativeElement as HTMLInputElement;
    const cursorPosition = inputElement.selectionStart || 0;
    const textBeforeCursor = inputElement.value.slice(0, cursorPosition);
    const mentionTriggerIndex = textBeforeCursor.lastIndexOf('[');

    if (mentionTriggerIndex !== -1) {
      this.mentionText = textBeforeCursor.slice(mentionTriggerIndex + 1);
      this.calculationFields = this.calcService.findMatchingFields(this.mentionText, this._uuid);
      this.highlightedIndex = 0;
    } else {
      this.calculationFields = [];
    }
  }

  selectCalculation(field: Field) {
    this.calculationFields = [];
    const inputElement = this.calculation_text.nativeElement as HTMLInputElement;
    const cursorPosition = inputElement.selectionStart || 0;
    const textBeforeCursor = inputElement.value.slice(0, cursorPosition);
    const textAfterCursor = inputElement.value.slice(cursorPosition);
    const mentionTriggerIndex = textBeforeCursor.lastIndexOf('[');

    const newText = textBeforeCursor.slice(0, mentionTriggerIndex + 1) + `${field.select_type_text}] ` + textAfterCursor;
    inputElement.value = newText;
    inputElement.setSelectionRange(
      mentionTriggerIndex + field.select_type_text.length + 2,
      mentionTriggerIndex + field.select_type_text.length + 2
    );
    this.calculation_text.nativeElement.focus();
  }

  saveCalculation() {
    this.calculation = this.calculation + ' ' + this.calculation_text.nativeElement.value;
    this.calcService.saveCalculation(this._uuid, this.calculation);
    this.calculation_text.nativeElement.value = '';
    this.calculationFields = [];
  }

  editCalculation() {
    this.calculation_text.nativeElement.value = this.calculation.trim();
    this.calculation = '';
    this.calculation_text.nativeElement.focus();
  }

  addArithmeticOperators(operator: string) {
    const currentPosition = this.calculation_text.nativeElement.selectionStart;
    const x = this.calculation_text.nativeElement.value;
    this.calculation_text.nativeElement.value = x.slice(0, currentPosition) + `${operator}` + x.slice(currentPosition);
  }

  addDecimal(event: KeyboardEvent) {
    const element = event.target as HTMLInputElement;
    this.calculation_decimal = element.value;
    this.calcService.updateDecimal(this._uuid, this.calculation_decimal);
  }

  /**
   * remove current calculation
   */
  removeCalculation() {
    this.calculation = '';
    this.calcService.removeCalculation(this._uuid);
  }
}
